import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from './firebase'

// Initialize Firebase Functions
const functions = getFunctions(app)

/**
 * Generate a tailored resume using OpenAI via Firebase Cloud Functions
 * @param {Object} profileData - The user's profile data
 * @param {string} jobDescription - The job description text
 * @returns {Promise<Object>} - The result of the function call
 */
export const generateResumeWithAI = async (profileData, jobDescription) => {
  try {
    const generateResumeFunction = httpsCallable(functions, 'generateResume')

    const result = await generateResumeFunction({
      profileData,
      jobDescription,
    })

    return result.data
  } catch (error) {
    console.error('Error calling generateResume function:', error)
    return {
      success: false,
      error: error.message || 'An error occurred while generating the resume',
    }
  }
}
